import React from 'react';

import { RenderSimpleHtml } from '@blockworks/ui/legacy/string';
import { cn } from '@blockworks/ui/utils';
import { useRouter } from 'next/router';

import UpcomingEvents from '@/components/data-fetchers/events/upcoming-events';
import Newsletter from '@/components/pages/frontpage/components/feature/right/newsletter';
import RecentResearch from '@/components/sections/right/recent-research';
import subscribeToNewsletter, { allNewsletters } from '@/utils/functions/subscribe-to-newsletter';
import { BeehiivPost } from '@/utils/functions/beehiiv/fetch-beehiiv-posts';
import ErrorPage from '@/components/pages/error-page';
import Breadcrumb from '@/components/display/headers/breadcrumb';

export type NewsletterDailyPageLayoutProps = {
    issue: BeehiivPost | null;
    recentArticle: any;
};

const NewsletterIssuePageLayout = (props: NewsletterDailyPageLayoutProps) => {
    const { issue, recentArticle } = props;
    const router = useRouter();
    const source = router.query?.utm_source ? `${router.query?.utm_source}` : 'newsletter-page';
    const campaign = router.query?.utm_campaign ? `${router.query?.utm_campaign}` : '';
    const medium = router.query?.utm_medium ? `${router.query?.utm_medium}` : 'organic';

    if (!issue) {
        return <ErrorPage statusCode={404} />;
    }

    return (
        <article className={cn('flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 gap-5')}>
            <section className="flex flex-row flex-wrap xl:flex-nowrap overflow-hidden">
                <div className="w-full lg:w-9/12 h-full p-10 border-r">
                    <div className="w-full">
                        <Breadcrumb
                            items={[
                                { title: 'newsletter', link: '/newsletter' },
                                {
                                    title: issue.title ?? '',
                                },
                            ]}
                        />
                    </div>
                    <RenderSimpleHtml html={issue.content?.free?.web ?? ''} className="mt-10" />
                </div>
                <div className="w-full lg:w-3/12 h-full">
                    <Newsletter
                        title="Newsletter"
                        subTitle="Blockworks Daily"
                        inputPlaceholder="Email address"
                        buttonText="Subscribe"
                        onButtonClick={email =>
                            subscribeToNewsletter(email, allNewsletters, source, router.asPath, campaign, medium)
                        }
                    />
                    <UpcomingEvents />
                    {recentArticle && <RecentResearch recentResearch={recentArticle} />}
                </div>
            </section>
        </article>
    );
};

export default NewsletterIssuePageLayout;
